'use strict';

function filterActus(g) {
  var filters = [];
  var currentPage = 1;
  var postType;

  function init() {
    postType = $('#main-content article').attr('data-post-type');

    var str = window.location.pathname;
    var obj = {};

    if (str.includes('toute-l-actu') || str.includes('actualites-voile')) {
      var url = new URL(window.location.href);
      // récupération des filtres
      var filtresInit = JSON.parse(url.searchParams.get('tags'));

      if (filtresInit !== null) {
        for (var index in filtresInit) {
          if (filtresInit.hasOwnProperty(index)) {
            filtresInit[index] != null ? filters.push(filtresInit[index]) : null;
          }
        }
      }

      // supp les null
      filters = filters.filter(function(el) {
        return el != null;
      });

      // rendre checked
      filters.forEach(function(item) {
        $('#'+item).prop('checked', true);
      });
    }

    $('.filtre__input').click(function(e) {
      $('.btn--load-actus').show();
      var filterValueSelected = $(this).attr('id');
      currentPage = 1;
      if ($(this).is(':checked')) {
        filters.push(filterValueSelected);
      } else {
        filters = filters.filter(function(filter) {
          return filter !== filterValueSelected;
        });
      }
      if (str.includes('toute-l-actu') || str.includes('actualites-voile')) {
        // redirige si actualites hors media
        Object.assign(obj, filters);
        var lienPageActus = str.includes('toute-l-actu') ? '/actualites/toute-l-actu/' : '/voile/actualites-voile/';

        window.location.href = lienPageActus + '?tags=' + encodeURIComponent(JSON.stringify(obj));
      } else {
        load(true);
      }
    });

    $('.btn--load-actus').click(function() {
      currentPage++;
      load(false);
    });

    // load(true);
  }

  function load(clean) {
    $sectionToutesActus = $('.section-toutes-actus');
    $blocActusList = $('.bloc-actus__list');

    $.ajax({
      url: loadMoreActus.ajaxurl,
      method: 'GET',
      data: {
        action: 'filteractus',
        postType: postType,
        page: currentPage,
        tag__and: filters
      },
      beforeSend: function() {
        $sectionToutesActus.addClass('is-loading ');
      },
      success: function(data) {
        data = JSON.parse(data);
        $sectionToutesActus.removeClass('is-loading ');
        var template = '';
        data.templates.forEach(function(item) {
          template = template.concat(item);
        });

        if (clean) {
          $blocActusList.html(template);
        } else {
          $blocActusList.append(template);
        }

        if ($('.bloc-actus__list ').children().length >= data.totalItems) {
          $('.btn--load-actus').hide();
        }
      },
      error: function(data) {
        console.log('Erreur…');
      }
    });
  }

  init();
}
